<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t(title) }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default"
						@click="addItem">
						{{ $t('Create Announcement') }}
					</button>
				</div>
				<!-- filter -->
				<div class="verified-icon-left text-center  ml-a"><i class="material-icons text-white absolute pt-1">sort</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-30">
						<button class="btn btn-filter-last-login p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="orderBy === 'id'">{{$t('All')}}</span>
								<span class="capitalize" v-if="orderBy === 'created_at'">{{$t('Created At')}}</span>
								<span class="capitalize" v-if="orderBy === 'type'">{{$t('Type')}}</span>
								<span class="capitalize" v-if="orderBy === 'is_published'">{{$t('Published')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="filterOrder('all')"><span class="text-center minw-85">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('created_at')"><span class="text-center minw-85">{{$t('Created At')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('type')"><span class="text-center minw-85">{{$t('Type')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('published')"><span class="text-center minw-85">{{$t('Published')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- sort -->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
					<div class="mr-3">
						<md-menu md-align-trigger :md-offset-x="-20">
							<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
									<span class="tf-none" v-if="sortBy === 'desc'">{{$t('Newest on top')}}</span>
									<span class="tf-none" v-if="sortBy === 'asc'">{{$t('Newest on last')}}</span>
							</button>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<md-menu-content>
								<md-menu-item @click="sortFilter('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
								<md-menu-item @click="sortFilter('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				<!-- counting -->
				<div class="mr-3">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th>{{ $t('No') }}</th>
						<th>{{ $t('Title') }}</th>
						<th>{{ $t('Type') }}</th>
						<th>{{ $t('Start Date') }}</th>
						<th>{{ $t('End Date') }}</th>
						<th>{{ $t('Created') }}</th>
						<th>{{ $t('Published') }}</th>
						<th width="20%"></th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in items"
						:key="item.id" @dblclick="editItem(item)">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.title }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}">
								{{ item.type }}
							</md-chip>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ dateFormat(item.start_date) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ dateFormat(item.end_date) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.created_at }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" v-if="item.is_published">Published</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" v-if="!item.is_published">Unpublished</td>
						<td class="btn-action-table" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<!-- Edit -->
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="editItem(item)"
								v-tooltip="'Edit'">
								<i class="material-icons md-18">edit</i>
							</button>
							<!-- Remove -->
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)"
								v-tooltip="'Remove'">
								<i class="material-icons md-18">delete</i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Announcements / Maintenances available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Form -->
			<announcement-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>

			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					{{ $t('Delete Announcements Size') }} {{ selected.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Yes, Delete It') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import AnnouncementForm from '@/components/AnnouncementForm.vue';
import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage, delay, dateFormat } from '@/lib/helper';
import announcementsApi from '@/api/announcements';

export default {
	name: 'Announcements',
	components: {
		Modal,
		AnnouncementForm,
		Pagination,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'id',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			title: 'Announcements',
			isFetching: false,
			hover: false,
			hoverItem: null,
		};
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			announcementsApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Display',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Display',
					text: message,
				});
			};
			announcementsApi.delete(item.id, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		dateFormat(date) {
			return dateFormat(date, 'YYYY-MM-DD HH:mm');
		},
		sortFilter(filter) {
			if (filter === 'asc') {
				this.sortBy = 'asc';
			} else {
				this.sortBy = 'desc';
			}
		},
		filterOrder(filter) {
			if (filter === 'all') {
				this.orderBy = 'id';
			} else if (filter === 'type') {
				this.orderBy = 'type';
			} else if (filter === 'published') {
				this.orderBy = 'is_published';
			} else {
				this.orderBy = 'created_at';
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetch();
	},
	watch: {
		sortBy() {
			this.fetch(true);
		},
		orderBy() {
			this.fetch(true);
		},
	},
};
</script>
